import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Switch from "react-switch";
import {
  HomePageContainer,
  HeaderWrapper,
  Image,
  HomeContainer,
  Wrapper,
  Card,
  CardColumn,
  CardContainer,
  CardImg,
  CardName,
  CardPrice,
  ChipInLoadBar,
  ChippedIn,
  CountContainer,
  Number,
  Scroll,
  CardDesc,
  Button,
  Buttons,
  Input,
  Inputs,
  InputRow,
  TextArea,
  Row,
  Label,
  Currency,
  AddButton,
  Photo,
  Photos,
  BackText,
  BackContainer,
  BackRow,
  ButtonDisabled,
  ModalTitle,
  ModalText,
  ModalRow,
  ModalButton,
  StyledText,
  StyledButton,
  UploadButton,
  ChooseFile,
  BoughtDiv,
  GiftLocation,
  BigButton,
  CardRow,
  CloseIcon,
  Relative,
  RemoveIcon,
  LoaderContainer,
  WishlistName,
  Username,
  TitleContainer,
  StyledUsername,
  StyledWishlistName,
} from "./WishlistPage.styles.js";

import Header from "../../components/Header/Header.js";
import Footer from "../../components/Footer/Footer.js";
import Modal from "../../components/Modal/Modal.js";
import openToast from "../../utils/toast.js";
import Loader from "../../components/Loader/Loader";

import {
  DEFAULT_LATITUDE,
  DEFAULT_LONGITUDE,
  getCurrencySymbol,
  googlePlacesKey,
  MAP_LIBRARIES,
  MAP_ZOOM_LEVEL,
  ONLINE_LOCATION_NAME,
} from "../../utils/constants.js";

import {
  GoogleMap,
  Marker,
  StandaloneSearchBox,
  useJsApiLoader,
} from "@react-google-maps/api";

import OrgLogo from "../../assets/images/orgLogo.png";
import GiftImg from "../../assets/images/gift.png";
import { priceFormatter } from "../../utils/utils.js";
import { ReactComponent as Back } from "../../assets/icons/chevron.svg";
import { ReactComponent as Loading } from "../../assets/icons/loader-white.svg";

import { selectedLocale } from "../../store/slices/common/slice.js";
import {
  selectGetUserMemberWishlistItemsPending,
  selectUpdateItemPending,
  selectUserInfo,
} from "../../store/slices/organization/slice.js";
import {
  getUserMemberWishlistItems,
  removeItemFromWishlist,
  updateItem,
} from "../../store/slices/organization/asyncThunks.js";
import {
  selectRemoveItemFromWishlistPending,
  selectUserWishlistItems,
} from "../../store/slices/organization/slice.js";

function MemberCard({
  item,
  index,
  setOpenRemoveModal,
  chipInPercentage,
  locale,
  deletingItemId,
  setDeletingItemId,
  setEdit,
  setItemData,
  removeLoading,
  t,
}) {
  return (
    <CardContainer>
      <CountContainer>
        <Number>{index + 1}</Number>
      </CountContainer>
      <CardRow>
        <Card $chipIn={item?.isChipInItem}>
          <CardImg src={item.photos[0]?.url} alt={`Item-photo-${index}`} />
          <CardColumn>
            <CardName>
              {item.name.length > 25
                ? item.name.slice(0, 25) + "..."
                : item.name}
            </CardName>
            <CardDesc>{item.description}</CardDesc>

            {item.isBought ? (
              <BoughtDiv>
                <CardPrice $isBought>
                  {priceFormatter(item.price, true, 15)}{" "}
                  {getCurrencySymbol(item.currency)}{" "}
                </CardPrice>
                <CardPrice
                  style={{
                    textTransform: "capitalize",
                  }}
                >
                  {t("bought")}
                </CardPrice>
              </BoughtDiv>
            ) : (
              <CardPrice>
                {priceFormatter(item.price, true, 15)}{" "}
                {getCurrencySymbol(item.currency)}
              </CardPrice>
            )}
            {item?.isChipInItem &&
              (chipInPercentage === 0 ? (
                <ChipInLoadBar $center>
                  {chipInPercentage.toFixed(0)}%
                </ChipInLoadBar>
              ) : (
                <ChipInLoadBar $center>
                  <ChippedIn
                    style={{
                      width: `${chipInPercentage}%`,
                    }}
                  >
                    {chipInPercentage.toFixed(0)}%
                  </ChippedIn>
                </ChipInLoadBar>
              ))}
          </CardColumn>

          {item.buyable && !item.isBought && (
            <div
              style={{
                position: "absolute",
                bottom: "10px",
                ...(locale === "en" && { right: "5px" }),
                ...(locale === "ar" && { left: "5px" }),
              }}
            >
              <div>
                <img
                  src={GiftImg}
                  alt="Gift-img"
                  style={{ userSelect: "none" }}
                />
              </div>
            </div>
          )}
        </Card>
        {!item?.isBought && (
          <Buttons>
            {item?.id === deletingItemId && removeLoading ? (
              <ButtonDisabled>
                <Loading width={16} height={16} />
              </ButtonDisabled>
            ) : (
              <Button
                onClick={() => {
                  setOpenRemoveModal(true);
                  setDeletingItemId(item.id);
                }}
              >
                {t("remove")}
              </Button>
            )}

            <Button
              onClick={() => {
                window.scrollTo(0, 0);
                setEdit(true);
                setItemData(item);
              }}
            >
              {t("edit")}
            </Button>
          </Buttons>
        )}
      </CardRow>
    </CardContainer>
  );
}

const WishlistPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const toastId = useRef(null);

  const locale = useSelector(selectedLocale);
  const ar = locale === "ar";

  const userInfo = useSelector(selectUserInfo);

  const [engName, setEngName] = useState("");
  const [arName, setArName] = useState("");
  const [edit, setEdit] = useState(false);
  const [engDesc, setEngDesc] = useState("");
  const [arDesc, setArDesc] = useState("");
  const [price, setPrice] = useState("");
  const [uploadedPhotos, setUploadedPhotos] = useState([]);
  const [logo, setLogo] = useState(null);
  const [location, setLocation] = useState({ lat: "", lng: "", name: "" });

  const [buyable, setBuyable] = useState(false);
  const [isVisible, setIsVisible] = useState(edit);
  const [openRemoveModal, setOpenRemoveModal] = useState(false);
  const [openGiftLocationModal, setOpenGiftLocationModal] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const [imageFiles, setImageFiles] = useState([]);

  const [deletingItemId, setDeletingItemId] = useState(null);
  const [itemData, setItemData] = useState({});

  const userWishlistItems = useSelector(selectUserWishlistItems);
  const removeLoading = useSelector(selectRemoveItemFromWishlistPending);
  const updateItemPending = useSelector(selectUpdateItemPending);
  const getUserMemberWishlistItemsPending = useSelector(
    selectGetUserMemberWishlistItemsPending
  );

  const handlePhotoUpload = (event) => {
    const files = Array.from(event.target.files);
    let lastIndex = uploadedPhotos.length;

    const fileURLs = files.map((file, index) => {
      let addIndex = lastIndex + index;
      setImageFiles((prev) => {
        return [...prev, { file, index: addIndex }];
      });
      return URL.createObjectURL(file);
    });

    setUploadedPhotos((prevPhotos) => [...prevPhotos, ...fileURLs]);
  };

  useEffect(() => {
    dispatch(getUserMemberWishlistItems({ id }));
  }, [dispatch, id]);

  useEffect(() => {
    let timer;
    if (edit) {
      setIsVisible(true);
    } else {
      timer = setTimeout(() => setIsVisible(false), 200);
    }

    return () => clearTimeout(timer);
  }, [edit]);

  useEffect(() => {
    if (!openGiftLocationModal) {
      setTimeout(() => {
        setShowMap(false);
      }, 200);
    }
  }, [openGiftLocationModal]);

  const handleChange = () => {
    setBuyable(!buyable);
  };

  const handleDelete = (itemId) => {
    setOpenRemoveModal(false);
    dispatch(removeItemFromWishlist({ itemId }))
      .unwrap()
      .then(() => {
        setDeletingItemId(null);
      })
      .catch((err) => {
        openToast(toastId, "active-org", "error", err.message);
      });
  };

  useEffect(() => {
    if (userInfo.organizationPhotoUrl) {
      setLogo(userInfo.organizationPhotoUrl);
    } else {
      setLogo(OrgLogo);
    }
  }, [userInfo]);

  useEffect(() => {
    if (itemData?.name) {
      setEngName(itemData?.name);
    }
    if (itemData?.nameAr) {
      setArName(itemData?.nameAr);
    }
    if (itemData?.description) {
      setEngDesc(itemData?.description);
    }
    if (itemData?.descriptionAr) {
      setArDesc(itemData?.descriptionAr);
    }
    if (itemData?.price) {
      setPrice(itemData?.price);
    }

    if (itemData?.buyable) {
      setBuyable(itemData?.buyable);
    }
    if (itemData?.photos?.length > 0) {
      // setUploadedPhotos(itemData?.photos);
      setUploadedPhotos(itemData.photos.map((p) => p.url));
    }
    if (itemData?.location) {
      setLocation(itemData?.location);
    }
  }, [itemData]);

  const searchBoxRef = useRef();
  const mapRef = useRef();
  const [mapZoom, setMapZoom] = useState(MAP_ZOOM_LEVEL);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: googlePlacesKey,
    libraries: MAP_LIBRARIES,
  });

  const center =
    location?.lat && location?.lng
      ? {
          lat: location.lat,
          lng: location.lng,
        }
      : {
          lat: DEFAULT_LATITUDE,
          lng: DEFAULT_LONGITUDE,
        };

  const handlePlacesChanged = (map) => {
    const places = searchBoxRef.current?.getPlaces();

    if (places && places.length > 0) {
      const place = places[0];
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      const address = place.formatted_address;
      setLocation({ lat, lng, name: address });

      if (mapRef.current) {
        mapRef.current.setCenter({ lat, lng });
        setMapZoom(14);
      }
    }
  };

  const handleMarkerDragEnd = (event) => {
    const { latLng } = event;
    const lat = latLng.lat();
    const lng = latLng.lng();
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === "OK" && results?.length > 0) {
        const address = results[0].formatted_address;
        setLocation({ lat, lng, name: address });
      }
    });
  };

  const handleMapClick = (event) => {
    const { latLng } = event;
    const lat = latLng.lat();
    const lng = latLng.lng();
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === "OK" && results?.length > 0) {
        const address = results[0].formatted_address;
        setLocation({ lat, lng, name: address });
      }
    });
  };

  const onLoad = useCallback(
    function callback(map) {
      mapRef.current = map;
      map.setCenter(center);
      map.setZoom(MAP_ZOOM_LEVEL);
    },
    [center]
  );

  const validateInput = () => {
    if (!uploadedPhotos.length) {
      openToast(
        toastId,
        "sign-up",
        "error",
        t("at-least-1-photo-must-be-added")
      );

      return false;
    }
    if (!engName) {
      openToast(toastId, "sign-up", "error", t("name-cant-be-empty"));

      return false;
    }
    if (!price) {
      openToast(toastId, "sign-up", "error", t("price-cant-be-empty"));

      return false;
    }
    if (price <= 0) {
      openToast(toastId, "sign-up", "error", t("price-must-be-positive"));

      return false;
    }

    if (!location.name) {
      openToast(toastId, "sign-up", "error", t("location-cant-be-empty"));

      return false;
    }
    if (!engDesc) {
      openToast(toastId, "sign-up", "error", t("description-cant-be-empty"));

      return false;
    }

    return true;
  };

  const onSubmit = () => {
    if (!validateInput(true)) {
      return;
    }

    dispatch(
      updateItem({
        id: itemData.id,
        engName,
        price,
        arDesc,
        engDesc,
        arName,
        uploadedPhotos,
        location,
        buyable,
        imageFiles: imageFiles.map((image) => image.file),
      })
    )
      .unwrap()
      .then(() => {
        setEdit(false);
        setItemData({});
      })
      .catch((err) => {
        openToast(toastId, "update-item", "error", err.message);
      });
  };

  const handleRemoveImage = (photo) => {
    const index = uploadedPhotos.indexOf(photo);
    setUploadedPhotos((prev) => {
      return prev.filter((uploadedPhoto) => uploadedPhoto !== photo);
    });

    setImageFiles((prev) => {
      return prev.filter((file) => file?.index !== index);
    });
  };

  return (
    <>
      <HeaderWrapper>
        <Header />
      </HeaderWrapper>

      <HomeContainer>
        {!getUserMemberWishlistItemsPending ? (
          <HomePageContainer>
            <BackContainer>
              <BackRow
                onClick={() => {
                  if (!edit) {
                    window.scrollTo(0, 0);
                    navigate("/dashboard");
                  } else {
                    window.scrollTo(0, 0);
                    setEdit(false);
                    setItemData({});
                  }
                }}
              >
                <Back />
                <BackText>{t("back")}</BackText>
              </BackRow>
            </BackContainer>
            {!isVisible && (
              <TitleContainer>
                <StyledUsername>@{state?.username}</StyledUsername>
                <StyledWishlistName>{state?.wishlistName}</StyledWishlistName>
              </TitleContainer>
            )}
            <Wrapper>
              {isVisible ? (
                <Scroll $open={edit}>
                  {uploadedPhotos.length > 0 ? (
                    <>
                      <Photos>
                        {uploadedPhotos.map((photo, index) => (
                          <Relative key={index}>
                            <Photo
                              key={index}
                              src={photo}
                              alt={`Uploaded ${index}`}
                            />
                            <RemoveIcon
                              onClick={() => {
                                handleRemoveImage(photo);
                              }}
                            />
                          </Relative>
                        ))}
                        <AddButton>
                          <ChooseFile
                            type="file"
                            multiple
                            $circle
                            accept="image/*"
                            onChange={handlePhotoUpload}
                          />
                          +
                        </AddButton>
                      </Photos>
                    </>
                  ) : (
                    <UploadButton>
                      <ChooseFile
                        type="file"
                        multiple
                        accept="image/*"
                        onChange={handlePhotoUpload}
                      />
                      {t("upload-photos")}
                    </UploadButton>
                  )}

                  <Inputs>
                    <Input
                      placeholder={t("english-name")}
                      value={engName}
                      onChange={(e) => setEngName(e.target.value)}
                    />
                    <Input
                      placeholder={t("arabic-name")}
                      value={arName}
                      onChange={(e) => setArName(e.target.value)}
                    />
                    <InputRow>
                      <Input
                        placeholder={t("price")}
                        $small
                        value={price}
                        onChange={(e) => setPrice(e.target.value)}
                      />
                      <Currency>{t("sar")}</Currency>
                    </InputRow>
                    <GiftLocation
                      onClick={(e) => setOpenGiftLocationModal(true)}
                    >
                      {location && location?.name
                        ? location?.name === ONLINE_LOCATION_NAME
                          ? t("online")
                          : t(location?.name)
                        : t("gift-location")}
                    </GiftLocation>
                    <TextArea
                      placeholder={t("arabic-description")}
                      value={arDesc}
                      onChange={(e) => setArDesc(e.target.value)}
                    />
                    <TextArea
                      placeholder={t("english-description")}
                      value={engDesc}
                      onChange={(e) => setEngDesc(e.target.value)}
                    />
                    <Row>
                      <Label>{t("buyable")}</Label>
                      <Switch
                        activeBoxShadow={"0px 0px 2px 3px #85a1ac"}
                        onColor="#85a1ac"
                        checkedIcon={false}
                        uncheckedIcon={false}
                        onChange={handleChange}
                        checked={buyable}
                      />
                    </Row>
                  </Inputs>

                  {updateItemPending ? (
                    <ButtonDisabled style={{ width: 95 }}>
                      <Loading width={16} height={16} />
                    </ButtonDisabled>
                  ) : (
                    <StyledButton
                      disabled={updateItemPending}
                      onClick={() => {
                        onSubmit();
                      }}
                    >
                      {t("edit")}
                    </StyledButton>
                  )}
                </Scroll>
              ) : (
                <Scroll $open={!edit}>
                  {userWishlistItems.length > 0 ? (
                    userWishlistItems.map((item, index) => {
                      const priceItem = priceFormatter(+item?.price, true, 15);
                      const chipInPercentage =
                        (+item?.paidChipIn / +priceItem) * 100;

                      return (
                        <MemberCard
                          key={item.id}
                          item={item}
                          index={index}
                          setOpenRemoveModal={setOpenRemoveModal}
                          chipInPercentage={chipInPercentage}
                          locale={locale}
                          deletingItemId={deletingItemId}
                          setDeletingItemId={setDeletingItemId}
                          setEdit={setEdit}
                          setItemData={setItemData}
                          removeLoading={removeLoading}
                          t={t}
                        />
                      );
                    })
                  ) : (
                    <StyledText>{t("user-no-products-in-wishlist")}</StyledText>
                  )}
                </Scroll>
              )}
            </Wrapper>
          </HomePageContainer>
        ) : (
          <LoaderContainer>
            <Loader />
          </LoaderContainer>
        )}

        <Footer ar={ar} />

        <Modal open={openRemoveModal} close={setOpenRemoveModal}>
          <ModalTitle>{t("remove-product-title")}</ModalTitle>
          <ModalText>{t("remove-product-text")}</ModalText>

          <CloseIcon onClick={() => setOpenRemoveModal(false)} />

          <ModalRow>
            <ModalButton onClick={() => setOpenRemoveModal(false)}>
              {t("no")}
            </ModalButton>
            <ModalButton
              $yes
              onClick={() => {
                handleDelete(deletingItemId);
              }}
            >
              {t("yes")}
            </ModalButton>
          </ModalRow>
        </Modal>

        <Modal open={openGiftLocationModal} close={setOpenGiftLocationModal}>
          <ModalTitle>{t("choose-gift-location")}</ModalTitle>
          <CloseIcon
            onClick={() => {
              setOpenGiftLocationModal(false);
            }}
          />

          {!showMap ? (
            <ModalRow>
              <BigButton
                onClick={() => {
                  setOpenGiftLocationModal(false);
                  setLocation({ lat: "", lng: "", name: "Online" });
                }}
              >
                {t("online")}
              </BigButton>
              <BigButton onClick={() => setShowMap(true)}>{t("map")}</BigButton>
            </ModalRow>
          ) : isLoaded ? (
            <>
              <StandaloneSearchBox
                onLoad={(ref) => {
                  searchBoxRef.current = ref;
                }}
                onPlacesChanged={handlePlacesChanged}
              >
                <Input
                  style={{
                    marginBottom: 8,
                    color: "white",
                    border: "1px solid white",
                  }}
                  type="text"
                  placeholder={t("search-for-location")}
                  value={location?.name}
                  onChange={(e) => {
                    setLocation((prevLocation) => ({
                      ...prevLocation,
                      name: e.target.value,
                    }));
                  }}
                />
              </StandaloneSearchBox>
              <GoogleMap
                mapContainerClassName="map"
                mapContainerStyle={{
                  border: "1px solid white",
                  width: "100%",
                  maxWidth: 800,
                  height: 400,
                  borderRadius: 15,
                  boxShadow:
                    "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
                }}
                onLoad={(map) => {
                  mapRef.current = map;
                  onLoad(map);
                }}
                zoom={mapZoom}
                onClick={handleMapClick}
              >
                <Marker
                  position={
                    location?.lat && location?.lng
                      ? {
                          lat: location.lat,
                          lng: location.lng,
                        }
                      : {
                          lat: DEFAULT_LATITUDE,
                          lng: DEFAULT_LONGITUDE,
                        }
                  }
                  draggable
                  onDragEnd={handleMarkerDragEnd}
                />
              </GoogleMap>
            </>
          ) : (
            <div style={{ marginTop: 50 }}>
              <Loading />
            </div>
          )}
        </Modal>
      </HomeContainer>
    </>
  );
};

export default WishlistPage;
